const { REACT_APP_PUBLIC_URL } = process.env;

/**
 * Absolute frontend URL for a path,
 * e.g. "/en/company" -> "https://www.iba-extrusion.de/en/company".
 * REACT_APP_PUBLIC_URL ends with a slash, so a plain concatenation would produce "//".
 * @param {string} path
 * @returns {string}
 */
// eslint-disable-next-line import/prefer-default-export
export const getAbsoluteUrl = (path = "") => {
  const base = (REACT_APP_PUBLIC_URL || "").replace(/\/+$/, "");

  return `${base}/${path.replace(/^\/+/, "")}`;
};
